import {DatePipe} from '@angular/common';
import * as moment from 'moment';
import {secureStorage} from "../functions/secure-storage";
import {GetLanguage, GetPreferredDate} from "../functions/shared-functions";
export const PageNumber = 0;
export const PageSize = 20;
export const today = new Date();
export const phone_pattern = '[- +()0-9]+';
export const httpsPattern = /^https:\/\//;
export const numbers_pattern = /^-?(0|[1-9]\d*)?$/;
export const currentLanguage = (secureStorage.getItem('lang') || 'ar');
export const dateFormat = currentLanguage === 'en' ? 'DD-MM-yyyy' : 'D MMM, yyyy';
export const dateTimeFormat = currentLanguage === 'en' ? 'DD/MM/YYYY, HH:MM A' : 'YYYY/MM/DD, HH:MM A';
export const monthDateFormat = currentLanguage === 'en' ? 'M/yyyy' : 'yyyy/M';
export const hijriFormat = 'iD iMMM، iYYYY';
export const datePipe = new DatePipe('en');
export const serverDate = 'DD/MM/yyyy'
export const serverDateTime = 'DD/MM/yyyy HH:MM'
export const serverTime = 'HH:mm a'
export const filterDate = 'yyyy-MM-DD'
export const password = /^(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\d])(?=.*[A-Z])(?=.*\d).{9,50}$/;
export const primaryColor = (window as any).primaryColor;
export const isMobile = window.innerWidth < 1000;
export const myIpAccessKey = '991dbc0aa9defca65d96090a8317460b';
export const defaultAvatar = 'assets/img/avatars/avatar.jpeg';
export const ArabicNumbersD = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
export const ArabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
export const EnglishNumbers = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];
export const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const momentDateFormat = (date, normal?, format?) => {
  if (normal) {
    return moment(date).format(format || dateFormat);
  } else {
    return reverseString(moment(date).format(format || dateFormat));
  }
};
export const momentMonthDateFormat = date => {
  return reverseString(moment(date).format('M/YYYY'));
};
const reverseString = str => {
  if (GetLanguage() === 'ar') {
    // moment.locale('ar_sa');
    return str.split('/').reverse().map(one => [...one].join(''))
      .toString().replaceAll(',', '/');
  } else {
    // moment.locale('en-us');
    return str;
  }
};
